<template>
    <div class="edit-content">
        <div class="left">
            <div class="left-item" v-for="(item, i) in 14" :key="i" :class="{rank: i + (pageIndex - 1) * 28 < 3, even: i + (pageIndex - 1) * 28 >=3 && i % 2 == 1, sing: i + (pageIndex - 1) * 28 >=3 && i % 2 == 0}" v-if="defaultdata[i + (pageIndex - 1) * 28]">
            <div class="rank-num">{{ i + (pageIndex - 1) * 28 + 1 }}</div>
            <div class="rank-name">姓名：{{ defaultdata[i + (pageIndex - 1) * 28].value1 }}</div>
            <div class="rank-line-bg">
                <div class="rank-active-bg" :style="`width: ${+defaultdata[i + (pageIndex - 1) * 28].value2 / +maxdata * 100}%`"></div>
            </div>
            <div class="rank-data">{{ defaultdata[i + (pageIndex - 1) * 28].value2 }}</div>
            </div>
        </div>
        <div class="right">
            <div class="left-item" v-for="(item, i) in 14" :key="i" :class="{even: i % 2 == 1, sing: i % 2 == 0}" v-if="defaultdata[i + (pageIndex - 1) * 28 + 14]">
            <div class="rank-num">{{ i + (pageIndex - 1) * 28 + 14 + 1 }}</div>
            <div class="rank-name">姓名：{{ defaultdata[i + (pageIndex - 1) * 28 + 14].value1 }}</div>
            <div class="rank-line-bg">
                <div class="rank-active-bg" :style="`width: ${+defaultdata[i + (pageIndex - 1) * 28 + 14].value2 / +maxdata * 100}%`"></div>
            </div>
            <div class="rank-data">{{ defaultdata[i + (pageIndex - 1) * 28 + 14].value2 }}</div>
            </div>
        </div>
        <div class="bottom">
            <span>共{{ Math.ceil(defaultdata.length / 28) }}页</span>
            <el-pagination
                background
                :pageSize="28"
                layout="prev, pager, next"
                :total="defaultdata.length"
                :current-page="pageIndex"
                @current-change="currentChange"
                :small="true">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import * as methods from './method.js'

export default {
    name: 'template.scope68',
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => {}
		}
    },
    data() {
        return {
            valueMap: [
                { name: "标题一", key: 'value1' },
                { name: "标题二", key: 'value2' },
            ],
            defaultdata: [
                { value1: '文本一', value2: '文本二' },
                { value1: '文本一', value2: '文本二' },
                { value1: '文本一', value2: '文本二' },
                { value1: '文本一', value2: '文本二' },
                { value1: '文本一', value2: '文本二' }
            ],
			exceldata: [],
            chartdata: [],
			apiconfig: {},
			scope: {},
			isApi: false,
            maxdata: 0,
            pageIndex: 1
        }
    },
    watch: {
        vdata(n) {
            if(n && n.length) {
                this.defaultdata = JSON.parse(JSON.stringify(n))
                this.pageIndex = 1
                this.setData()
            }
        },
        jsondata(n) {
            if(n && n.length) {
                this.exceldata = n
            }
        }
    },
    methods: {
		...methods,
        currentChange(e) {
            this.pageIndex = e
        },
        setdata() {
            this.maxdata = Math.max(...this.defaultdata.map(item => +item.value2))
            this.defaultdata = this.defaultdata.sort((a, b) => +b.value2 - +a.value2)
        },
    },
    mounted() {
		if (this.vdata && this.vdata.length) {
            this.defaultdata = JSON.parse(JSON.stringify(this.vdata))
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
        this.setData()
        setTimeout(() => {
            this.setdata()
        }, 200);
    }
}
</script>

<style lang="scss" scoped>
.edit-content {
    height: 928px;
    width: 1826px;
    margin: -36px auto 0;
    background: url('@/assets/temimg4/center-bg.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    pointer-events: auto;
    position: relative;
    .left {
      width: calc(50% - 52px);
      height: calc(100% - 52px);
      padding: 52px 0 0 52px;
    }
    .left-item {
      width: 857px;
      height: 52px;
      margin-top: 4px;
      display: flex;
      align-items: center;
      &.rank {
        background: url(@/assets/temimg4/item-rank.png) no-repeat;
        background-size: 100% 100%;
        .rank-num {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 26px;
          color: #90C2FF;
          line-height: 27px;
          font-style: italic;
          background: linear-gradient(0deg, #8FFDE9 0%, #EEFFFE 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
      }
      &.even {
        background: url(@/assets/temimg4/item-even.png) no-repeat;
        background-size: 100% 100%;
      }
      &.sing {
        background: url(@/assets/temimg4/item-sing.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .right {
      width: calc(50% - 52px);
      height: calc(100% - 52px);
      padding: 52px 0 0 52px;
    }
    .rank-num {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 21px;
      color: #D6F1FF;
      line-height: 27px;
      margin-left: 50px;
      width: 20px;
      margin-right: 90px;
    }
    .rank-name {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #D5E8FF;
      line-height: 27px;
      width: 136px;
      margin-right: 55px;
    }
    .rank-line-bg {
      width: 345px;
      height: 13px;
      background: #123652;
      border-radius: 7px;
      position: relative;
      margin-right: 64px;
    }
    .rank-active-bg {
      background: #57B4D7;
      border-radius: 7px;
      position: absolute;
      left: 0;
      height: 100%;
    }
    .rank-data {
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #FFDE43;
      line-height: 27px;
    }
}
.bottom {
  margin-top: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 42px;
  left: 50%;
  transform: translateX(-50%);
  >span {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #90D4FF;
    line-height: 14px;
  }
  .loadgroup {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    column-gap: 24px;
    .load-btn {
      font-size: 16px;
      padding: 4px 8px;
      border-radius: 4px;
      border: 1px solid #90D4FF;
      color: #90D4FF;
      cursor: pointer;
    }
  }
}
</style>
<style lang="scss">
.edit-content {
    .el-pagination  {
        display: flex;
        justify-content: center;
        .btn-prev, .btn-next {
            background: transparent !important;
            color: #A6DAFF !important;
            border: 1px solid #1e4265;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
                color: #fff !important;
            }
        }
        .el-pager {
            li {
                color:  #A5B1BC !important;
                background: transparent !important;
                border: 1px solid #1e4265;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                &.active, &:hover {
                    color: #fff !important;
                    border-color: #1b5ba2;
                    background: #134379 !important;
                }
            }
        }
    }
}
</style>